import {
  LocaleProvider,
  LocaleSettingsProvider,
  resolveDefaultLocaleSettings,
} from '@xhubio-saas/country-specifics-frontend'
import { type ReactNode, useMemo } from 'react'
import { useOrgLocale } from '../lib/useOrgLocale'

/**
 * App-Root wrapper that publishes the resolved org locale via
 * `<LocaleProvider>` (for `useLocale()`) and seeds `<LocaleSettingsProvider>`
 * with org-derived default formatting settings (for `useLocaleFormatter()`),
 * so date/number formatting is locale-correct app-wide.
 *
 * The settings are derived client-side from the org locale for now; user
 * overrides will plug in once `preferences.resolveLocale` is wired up.
 */
export function LocaleWrapper({ children }: { children: ReactNode }) {
  const locale = useOrgLocale()
  const settings = useMemo(() => resolveDefaultLocaleSettings(locale), [locale])
  return (
    <LocaleProvider locale={locale}>
      <LocaleSettingsProvider settings={settings}>{children}</LocaleSettingsProvider>
    </LocaleProvider>
  )
}
